<template>
    <textarea class="form-control"></textarea>
</template>
<script>
    import '@/assets/vendors/summernote/summernote-bs4.css'
    import '@/assets/vendors/summernote/summernote-bs4.js'
    export default{
        name: 'summernote',
        props : {
            model: {
                required: true
            },
            height: {
                type: String,
                default: '150'
            }
        },
        mounted() {
            let config = {
                height: this.height,
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'underline', 'clear', 'fontsize']],
                    ['fontname', ['fontname']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['view', ['fullscreen', 'help']],
                ],
                placeholder: 'Create your cover letter...'
            }
            let vm = this
            config.callbacks = {
                onInit: function () {
                    $(vm.$el).summernote("code", vm.model)
                },
                onChange: function () {
                    vm.$emit('update:model', $(vm.$el).summernote('code'))
                }
            }
            $(this.$el).summernote(config)
        }
    }
</script>